import { createSlice } from '@reduxjs/toolkit';
import { IPage, ITeamLeadAPIReducer } from 'src/pages/TeamLeadDashboard/interface';
import { IAllAgentsReducer, IPageData } from '../pages/AllAgents/interface';

const initialState = {
  totalActiveAgent: 0,
  teamLeadData: [],
  page: {} as IPage,
  loading: false,
  error: '',
  filters: {
    agentType: [],
    interactionStatus: [],
    paymentStatus: [],
    agentReferenceId: {}
  } as ITeamLeadAPIReducer['filters'],
  allAgentsData: [] as IAllAgentsReducer['allAgentsData'],
  allAgentsPage: {} as IPageData,
  isLoading: false,
  isDrawerOpen: false,
  isEmailMandatory: {
    emailsMandatory: false
  },
  searchValue: '',
  agentPreferences: {
    agentCenters: [],
    languageList: [],
    stateList: [],
    regionList: [
      {
        region: '',
        displayableRegionText: '',
        states: []
      }
    ],
    cityList: []
  },
  bucketGroup: [],
  availableRoles: {
    roles: [],
    userReferenceId: ''
  },
  agentRefId: '',
  allAgentsFilters: [
    { AGENCY_CODE: [] },
    { AGENT_ROLE: [] },
    { BUCKET_GROUP: [] },
    { PRIMARY_LANGUAGE: [] },
    { AGENT_STATE: [] },
    { STATUS: [] }
  ],
  agentCorporateNumbers: {
    userReferenceId: '',
    userNumberMappings: []
  },
  viewReportStatus: {
    data: [],
    loading: false,
    page: {
      pageNo: 1,
      pageSize: 20,
      totalElements: 0,
      totalPages: 0
    }
  }
};

const teamLeadSlice = createSlice({
  name: 'teamLeadDashboard',
  initialState,
  reducers: {
    setTeamLeadData(state, action) {
      const { data, pages } = action.payload;
      state.teamLeadData = data;
      state.page = pages;
    },
    setTeamLeadApiCalling(state) {
      state.loading = !state.loading;
    },
    setFilters(state, action) {
      const { data } = action.payload;
      state.filters = data;
    },
    setAllAgentsData(state, action) {
      const { data, pages, totalActiveAgent } = action.payload;
      state.allAgentsData = data;
      state.allAgentsPage = pages;
      state.totalActiveAgent = totalActiveAgent;
    },
    setAllAgentsApiCalling(state) {
      state.isLoading = !state.isLoading;
    },
    setIsDrawerOpen(state, action) {
      state.isDrawerOpen = action.payload;
    },
    setIsEmailMandatoryForAgencyCode(state, action) {
      state.isEmailMandatory = action.payload;
    },
    setSearchValue(state, action) {
      state.searchValue = action.payload;
    },
    setAgentPreferences(state, action) {
      state.agentPreferences = action.payload;
    },
    setBucketGroup(state, action) {
      state.bucketGroup = action.payload;
    },
    setAvailableRoles(state, action) {
      state.availableRoles = action.payload;
    },
    setAgentRefId(state, action) {
      state.agentRefId = action.payload;
    },
    setAllAgentsFilters(state, action) {
      state.allAgentsFilters = action.payload;
    },
    setViewReportStatusData(state, action) {
      const data = action.payload;
      state.viewReportStatus.data = data;
    },
    setViewReportStatusLoading(state, action) {
      state.viewReportStatus.loading = action.payload;
    },
    setViewReportStatusPage(state, action) {
      const { pageNo, pageSize, totalElements, totalPages } = action.payload;
      state.viewReportStatus.page = { pageNo, pageSize, totalElements, totalPages };
    },
    setAgentCorporateNumbers(state, action) {
      state.agentCorporateNumbers = action.payload;
    }
  }
});

export const {
  setTeamLeadData,
  setTeamLeadApiCalling,
  setFilters,
  setAllAgentsData,
  setAllAgentsApiCalling,
  setIsDrawerOpen,
  setIsEmailMandatoryForAgencyCode,
  setSearchValue,
  setAgentPreferences,
  setBucketGroup,
  setAvailableRoles,
  setAgentRefId,
  setAllAgentsFilters,
  setViewReportStatusData,
  setViewReportStatusLoading,
  setViewReportStatusPage,
  setAgentCorporateNumbers
} = teamLeadSlice.actions;

export default teamLeadSlice.reducer;
